import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { PALETTE_ITEMS, pushRecentPage } from '../config/globalSearchConfig';

/** Tracks visited routes for Ctrl+K recent pages section. */
export function useTrackRecentPages() {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;
    const match =
      PALETTE_ITEMS.find((item) => item.path === path) ||
      PALETTE_ITEMS.find((item) => path.startsWith(`${item.path}/`));

    if (match) {
      pushRecentPage({ id: match.id, label: match.label, path: match.path });
    }
  }, [location.pathname]);
}
